// Generated file : do not modify
export enum ManualBillingDocumentKinds
{
  NONE = 0,
  INVOICE,
  CREDIT_NOTE,
  CREDIT,
  DEBIT
};

export enum ManualBillingDocumentLedgerCodes
{
  NONE = 0,
  VTE,
  ABO
};

export enum ManualBillingDocumentStatuts
{
  NONE = 0,
  DRAFT,
  PROPOSED,
  ISSUED,
  CANCELLED,
  WAITING_PAYMENT
};

import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Factures et avoirs manuels
export default class ManualBillingDocument  {
  // Identifiant unique
  public id: number;
  // Établissement
  public owner: Owner;
  // Établissement
  public etablissementId: number;
  // Nature
  public kind: ManualBillingDocumentKinds;
  // Prendre en compte dans le panier
  public inCart: boolean | null;
  // Type comptable
  public ledgerCode: ManualBillingDocumentLedgerCodes;
  // Statut
  public statut: ManualBillingDocumentStatuts;
  // Date du document
  public effectiveAt: Date;
  // Pièce comptable
  public documentReference: string;
  // Référence
  public reference: string;
  // Libellé
  public label: string;
  // Montant HT
  public amountHt: number;
  // Taux de TVA (%)
  public vatRate: number;
  // Montant TVA
  public amountTva: number;
  // Montant TTC
  public amountTtc: number;
  // Mode de règlement
  public paymentMethod: string;
  // Facture générée
  public billId: number;
  // Écriture de compte
  public accountEntryId: number;
  // Type de la source
  public sourceType: ObjTypes;
  // Identifiant de la source
  public sourceId: number;
  // Motif de la proposition
  public proposalReason: string;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Type
  public ownerType: number;
  // Identifiant
  public ownerId: number;
  // Nom
  public ownerLabel: string;

  constructor() {
    this.id = 0;
    this.owner = new Owner();
    this.etablissementId = 0;
    this.kind = ManualBillingDocumentKinds.NONE;
    this.inCart = null;
    this.ledgerCode = ManualBillingDocumentLedgerCodes.NONE;
    this.statut = ManualBillingDocumentStatuts.NONE;
    this.effectiveAt = new Date(1901,1,1,0,0,0,0);
    this.documentReference = '';
    this.reference = '';
    this.label = '';
    this.amountHt = 0;
    this.vatRate = 0;
    this.amountTva = 0;
    this.amountTtc = 0;
    this.paymentMethod = '';
    this.billId = 0;
    this.accountEntryId = 0;
    this.sourceType = ObjTypes.NONE;
    this.sourceId = 0;
    this.proposalReason = '';
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.ownerType = 0;
    this.ownerId = 0;
    this.ownerLabel = '';
  }

  public static fromJson (obj: ManualBillingDocument): ManualBillingDocument {
    const newManualBillingDocument: ManualBillingDocument = new ManualBillingDocument();
    newManualBillingDocument.id = obj.id;
    newManualBillingDocument.owner = JSON.parse(JSON.stringify(obj.owner));
    newManualBillingDocument.etablissementId = obj.etablissementId;
    newManualBillingDocument.kind = obj.kind;
    newManualBillingDocument.inCart = obj.inCart;
    newManualBillingDocument.ledgerCode = obj.ledgerCode;
    newManualBillingDocument.statut = obj.statut;
    newManualBillingDocument.effectiveAt = new Date(obj.effectiveAt);
    newManualBillingDocument.documentReference = obj.documentReference;
    newManualBillingDocument.reference = obj.reference;
    newManualBillingDocument.label = obj.label;
    newManualBillingDocument.amountHt = obj.amountHt;
    newManualBillingDocument.vatRate = obj.vatRate;
    newManualBillingDocument.amountTva = obj.amountTva;
    newManualBillingDocument.amountTtc = obj.amountTtc;
    newManualBillingDocument.paymentMethod = obj.paymentMethod;
    newManualBillingDocument.billId = obj.billId;
    newManualBillingDocument.accountEntryId = obj.accountEntryId;
    newManualBillingDocument.sourceType = obj.sourceType;
    newManualBillingDocument.sourceId = obj.sourceId;
    newManualBillingDocument.proposalReason = obj.proposalReason;
    newManualBillingDocument.createId = obj.createId;
    newManualBillingDocument.failed = obj.failed;
    newManualBillingDocument.canUpdate = obj.canUpdate;
    newManualBillingDocument.canDelete = obj.canDelete;
    newManualBillingDocument.display = obj.display;
    newManualBillingDocument.notifDefType = obj.notifDefType;
    newManualBillingDocument.ownerType = obj.ownerType;
    newManualBillingDocument.ownerId = obj.ownerId;
    newManualBillingDocument.ownerLabel = obj.ownerLabel;
    return newManualBillingDocument;
  }

  public toJsonManualBillingDocument (): string {
    const json = {
      owner: this.owner,
      etablissementId: this.etablissementId,
      kind: this.kind,
      inCart: this.inCart,
      ledgerCode: this.ledgerCode,
      statut: this.statut,
      effectiveAt: this.effectiveAt ? new Date (this.effectiveAt).toString() : this.effectiveAt,
      documentReference: this.documentReference,
      reference: this.reference,
      label: this.label,
      amountHt: this.amountHt,
      vatRate: this.vatRate,
      amountTva: this.amountTva,
      amountTtc: this.amountTtc,
      paymentMethod: this.paymentMethod,
      billId: this.billId,
      accountEntryId: this.accountEntryId,
      sourceType: this.sourceType,
      sourceId: this.sourceId,
      proposalReason: this.proposalReason,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromManualBillingDocument (obj: ManualBillingDocument): void {
    this.id = obj.id;
    this.owner = obj.owner;
    this.etablissementId = obj.etablissementId;
    this.kind = obj.kind;
    this.inCart = obj.inCart;
    this.ledgerCode = obj.ledgerCode;
    this.statut = obj.statut;
    this.effectiveAt = new Date(obj.effectiveAt);
    this.documentReference = obj.documentReference;
    this.reference = obj.reference;
    this.label = obj.label;
    this.amountHt = obj.amountHt;
    this.vatRate = obj.vatRate;
    this.amountTva = obj.amountTva;
    this.amountTtc = obj.amountTtc;
    this.paymentMethod = obj.paymentMethod;
    this.billId = obj.billId;
    this.accountEntryId = obj.accountEntryId;
    this.sourceType = obj.sourceType;
    this.sourceId = obj.sourceId;
    this.proposalReason = obj.proposalReason;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.ownerType = obj.ownerType;
    this.ownerId = obj.ownerId;
    this.ownerLabel = obj.ownerLabel;
  }

  public compareManualBillingDocument (value: ManualBillingDocument): boolean {
    return (this.toJsonManualBillingDocument() == value.toJsonManualBillingDocument());
  }

  public cloneManualBillingDocument (): ManualBillingDocument {
    return ManualBillingDocument.fromJson(this);
  }

  public createForStoreManualBillingDocument (): Promise<ManualBillingDocument> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/manualbillingdocuments/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromManualBillingDocument(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreManualBillingDocument (): Promise<ManualBillingDocument> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/manualbillingdocuments/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromManualBillingDocument(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/manualbillingdocuments/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static issue (manualBillingDocument: ManualBillingDocument): Promise<ManualBillingDocument> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/manualbillingdocuments/issue', manualBillingDocument, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(ManualBillingDocument.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static cancel (manualBillingDocument: ManualBillingDocument): Promise<ManualBillingDocument> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/manualbillingdocuments/cancel', manualBillingDocument, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(ManualBillingDocument.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static vatPolicy (): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/manualbillingdocuments/vatPolicy', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/ManualBillingDocuments/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = ManualBillingDocument.fromJson(listData.reccords[0] as ManualBillingDocument);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<ManualBillingDocument> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/ManualBillingDocuments/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = ManualBillingDocument.fromJson(listData.reccords[0] as ManualBillingDocument);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(manualBillingDocuments: ManualBillingDocument[]) {
    manualBillingDocuments.forEach((item) => {
      item.effectiveAt = item.effectiveAt ? new Date(item.effectiveAt) : item.effectiveAt;
    })
  }
}
